var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVesselStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 28.584 7.43 L 23 14.981 L 23 67 L 46 67 L 45.974 41.25 L 45.948 15.5 L 40.058 7.69 L 34.168 -0.121 L 28.584 7.43",
    fillRule: "nonzero",
    fill: "#ffffff",
    strokeWidth: 1,
    stroke: "#CC8EC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVesselStandard);
export default __webpack_public_path__ + "static/media/vessel-standard.3e33dd0e6003d153c0f474485840d08e.svg";
export { ForwardRef as ReactComponent };